import React, {useState} from 'react'
import './EditCensorModal.css'; // Genbrug styles



export default function CreateStudentModal({schoolID, onClose, onCreate}){

    const [formData,setFormData] = useState({
        school_id: schoolID,
        cpr: '', 
        fornavne: '', 
        efternavn: '', 
        vejnavn: '', 
        husnummer: '', 
        postnummer: '',
        by: '',
        land: '',
        telefon: '',
        studie: '' 
    })
    function handleSubmit(e){
        e.preventDefault()
        onCreate(formData)
    }
//har fjernet "onClick=onClose", da den hele tiden lukker modalen
//      <div className="modal-overlay" onClick={onClose}>
// der er ikke nogen stop-propagation function?? <div className="modal-content" onClick={e => e.stopPropagation()}>
    return(
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2 className="modal-title">Opret kursist</h2>
                    <button className="close-btn" onClick={onClose}>&times;</button> 
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-form-grid">
                        <div className="form-group">
                            <label>CPR-nummer:</label>     
                            <input value={formData.cpr} onChange={e => setFormData({...formData, cpr: e.target.value})} required/>
                        </div>
                        <div className="form-group">
                            <label>Fornavn(e):</label>
                            <input value={formData.fornavne} onChange={e=>setFormData({...formData, fornavne: e.target.value})} required/>
                        </div>
                        <div className="form-group">
                            <label>Efternavn:</label>
                            <input value={formData.efternavn} onChange={e=> setFormData({...formData, efternavn: e.target.value})}/>
                        </div>
                        <div className="form-group">
                            <label>Gade:</label>
                            <input value={formData.gade} onChange={e=> setFormData({...formData, gade: e.target.value})} />
                        </div>
                        <div className="form-group">
                            <label>Nummer:</label>
                            <input valur={formData.nummer} onChange={e=> setFormData({...formData, nummer: e.target.value})}/>
                        </div>
                        <div className="form-group">
                            <label>Postnummer:</label>
                            <input value={formData.postnummer} onChange={e=> setFormData({...formData, postnummer: e.target.value})}/>
                        </div>
                        <div className="form-group">
                            <label>By:</label>
                            <input value={formData.by} onChange={e=> setFormData({...formData, by: e.target.value})} />
                        </div>
                        <div className="form-group">
                            <label>Land:</label>
                            <input value={formData.land} onChange={e=> setFormData({...formData, land: e.target.value})}/>
                        </div>
                        <div className="form-group">
                            <label>Studieretning:</label>
                            <select value={formData.studie} onChange={e=> setFormData({...formData, studie: e.target.value})}>
                                <option value="DU1">DU1</option>
                                <option value="DU2">DU2</option>
                                <option value="DU3">DU3</option>
                            </select>
                        </div>
                    </div>
                    <div className="modal-actions" style={{marginTop: '20px'}}>
                        <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
                        <button type="submit" className="btn-save">Opret kursist</button>
                    </div>
                </form>
            </div>            
        </div>
    )
}